// 固定フッターボタンがあれば、その高さに応じて body の下余白を調整するスクリプト
function applyFixedButtonSpacer() {
    const button = document.querySelector('.l23b-fixed-button-front');
    if (!button) {
        document.body.style.paddingBottom = '';
        return;
    }

    // トップへボタンもあれば上に上げる
    const pageTop = document.querySelector('.c-page-top');
    const pageTopBottom = pageTop ? parseFloat(getComputedStyle(pageTop).bottom || '0') || 0 : 0;

    const updatePadding = () => {
        const height = button.offsetHeight;
        document.body.style.paddingBottom = `${height}px`;
        if (pageTop) {
            pageTop.style.bottom = `${height + pageTopBottom}px`;
        }
    };

    updatePadding();

    const observer = new ResizeObserver(() => {
        updatePadding();
    });

    observer.observe(button);
    window.addEventListener('resize', updatePadding);
}
window.addEventListener('DOMContentLoaded', applyFixedButtonSpacer);

export{};